module.exports = __webpack_public_path__ + "static/diy_recipe_bath_bombs-481d975317c387d999f019eaddcd14cb.pdf";